import { render, staticRenderFns } from "./ScreenItemsTeacher.vue?vue&type=template&id=16d155f3&scoped=true&"
import script from "./ScreenItemsTeacher.vue?vue&type=script&lang=js&"
export * from "./ScreenItemsTeacher.vue?vue&type=script&lang=js&"
import style0 from "./ScreenItemsTeacher.vue?vue&type=style&index=0&id=16d155f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d155f3",
  null
  
)

export default component.exports